import { axios } from 'lib/axios';

export const loginWithEmailAndPassword = (data) => {
  return axios.post('/user/passwordLogin', data);
};
